<!--
---
--- Add or remove users
---
-->
<template>
    <v-combobox class="my-users-combobox"
                v-model="usersValidated"
                :label="$t('attributes.userEMails')"
                :disabled="disabled"
                chips
                prepend-icon="how_to_reg"
                solo
                multiple>
        <template v-slot:selection="data">
            <v-chip :selected="data.selected" :disabled="disabled"
                    :close="!disabled && data.item != $store.state.user.email"
                    @input="remove(data.item)">
                <strong>{{ data.item }}</strong>&nbsp;
            </v-chip>
        </template>
    </v-combobox>

</template>

<script>
    export default {
        name: "my-users-combobox",

        props: {company: Object, disabled: Boolean, usersProp: Array},

        data: () => ({
            users: []

        }),

        computed: {
            usersValidated: {
                get: function () {
                    return this.users
                },
                set: function (array) {
                    var emailFilter = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+.)+([a-zA-Z0-9]{2,4})+$/;
                    this.users = array
                        .flatMap(entry => entry.split(/,|;| /))
                        .filter(email => emailFilter.test(email))
                }
            }
        },

        methods: {
            remove(item) {
                this.users.splice(this.users.indexOf(item), 1)
            }
        },

        watch: {
            // We activate the save button only when anything was changed
            users: {
                // eslint-disable-next-line
                handler(newVal, oldVal) {
                    this.$emit('users', newVal);
                }
            },

            // setup initial value when the company is changed
            usersProp: {
                immediate: true,
                // eslint-disable-next-line
                handler(newVal, oldVal) {
                    this.users = newVal.slice(0)
                }
            }
        }
    }

</script>

<style scoped>
    .my-users-combobox {
        padding-left: 20px;
        padding-right: 20px;
    }
</style>